<template>
  <div class="layout-col">
    <empty v-if="list && list.length == 0" text="暂无数据" />
    <div
      class="layout-col ti-item"
      v-for="(item, index) of list"
      :key="item.chapter_id"
    >
      <div
        class="layout-row ti-item-title f-j-b"
        @click="tikuItemSelect(item, item.chapter_id, ee)"
      >
        <div class="layout-row left f-c">
          <div v-if="item.list.length > 0">
            <transition
              :name="tabIndex == item.chapter_id ? 'downIco1' : 'downIco2'"
              mode="out-in"
            >
              <img
                key="1"
                class="down"
                v-if="tabIndex == item.chapter_id"
                src="../image/icon_one_list_down.png"
                alt=""
              />
              <img
                key="2"
                class="down"
                v-if="tabIndex != item.chapter_id"
                src="../image/ico_ti_ku_down.png"
                alt=""
              />
            </transition>
          </div>

          <div class="font-16-000 title">
            <div class="ellipsis" style="width: 100%">
              {{ item.title }}
            </div>

            <img
              v-if="is_record(item)"
              class="record"
              src="../image/icon_doing_continue.png"
            />
          </div>
        </div>
        <div v-if="type == 'clearance'" class="layout-row right2">
          <img src="../image/gray_next.png" alt="" />
        </div>
        <div v-if="type == 'cuti'" class="layout-row right2">
          <div class="font-13-666">{{ item.count }}道</div>
          <img src="../image/gray_next.png" alt="" />
        </div>
        <div
          v-if="type == 'index'"
          class="layout-row right"
          :class="{ unlock: item.is_unlock == 0 }"
        >
          <img
            v-if="item.is_unlock == 0"
            src="../image/share_lock_icon.png"
            alt=""
          />
          <div class="layout-col f-j-c f-c Progress1">
            <div class="font-11-666">
              {{ item.wrong_count + item.right_count }}/{{ item.count }}
            </div>
            <div class="body">
              <div class="div">
                <div
                  :style="`width: ${(item.right_count / item.count) * 100}%`"
                ></div>
                <div
                  :style="`width: ${(item.wrong_count / item.count) * 100}%`"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="down">
        <div class="ti-item-body" v-if="tabIndex == item.chapter_id">
          <div
            class="layout-row item f-c f-j-b"
            v-for="e of item.list"
            :key="e.chapter_id"
            :style="e.count == 0 && 'opacity: 0.5'"
            @click="push_choice(e, item)"
          >
            <div class="font-15-000 title">
              <div class="ellipsis" style="width: 100%">
                {{ e.title }}
              </div>

              <img
                v-if="is_record2(e)"
                class="record"
                src="../image/icon_doing_continue.png"
              />
            </div>
            <div v-if="type == 'clearance'" class="layout-row right2">
              <img src="../image/gray_next.png" alt="" />
            </div>
            <div v-if="type == 'cuti'" class="layout-row right2">
              <div class="font-13-666">{{ item.count }}道</div>
              <img src="../image/gray_next.png" alt="" />
            </div>
            <div v-if="type == 'index'" class="layout-col f-j-e f-c Progress2">
              <div class="font-11-666">
                {{ e.wrong_count + e.right_count }}/{{ e.count }}
              </div>
              <div class="body">
                <div class="div">
                  <div
                    :style="`width: ${(e.right_count / e.count) * 100}%`"
                  ></div>
                  <div
                    :style="`width: ${(e.wrong_count / e.count) * 100}%`"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: ["list", "record", "type", "is_lock"],
  data() {
    return {
      tabIndex: -1,
      ee: {},
    };
  },
  created() {
    console.log(this.list, "list");
  },
  methods: {
    is_record(item) {
      if (!this.record) {
        return !!this.record;
      }
      return item.chapter_id == this.record.chapter_parent_id;
    },
    is_record2(e) {
      if (!this.record) {
        return !!this.record;
      }
      return (
        e.parent_id == this.record.chapter_parent_id &&
        e.chapter_id == this.record.chapter_id
      );
    },
    push_choice(e, item) {
      if (item != undefined) {
        e.chapter_title = item.title;
      }
      if (e.count == 0) {
        this.$toast.center("暂无题目");
        return;
      }
      this.$emit("tap", e);
    },
    tikuItemSelect(item, index, tabItem) {
      if (item.is_unlock == 0 && this.is_lock != 1) {
        lockTap.bind(this)(item);
        // this.$emit("lock", {
        //   show: true,
        //   data: item,
        // });
        return;
      } else {
        if (item.list.length == 0) {
          this.push_choice(item);
        } else {
          if (this.tabIndex == index) {
            this.tabIndex = -1;
          } else {
            this.tabIndex = index;
          }
        }
      }
      this.count++;
    },
  },
};
</script>

<style lang="scss" scoped>
.down-enter-active {
  transition: opacity 0.1s;
}
.down-leave-active {
  transition: opacity 0s;
}
.down-enter,
.down-leave-to {
  opacity: 0;
}

.downIco1-enter {
  transform: rotateZ(90deg);
}
.downIco1-enter-active {
  transition: all 0.1s ease;
}
.downIco1-enter-to {
  transform: rotateZ(0deg);
}
.downIco1-leave {
  transform: rotateZ(0);
}
.downIco1-leave-active {
  transition: all 0.1s ease;
}
.downIco1-leave-to {
  transform: rotateZ(-90deg);
}

.downIco2-enter {
  transform: rotateZ(-90deg);
}
.downIco2-enter-active {
  transition: all 0.1s ease;
}
.downIco2-enter-to {
  transform: rotateZ(0deg);
}
.downIco2-leave {
  transform: rotateZ(0);
}
.downIco2-leave-active {
  transition: all 0.1s ease;
}
.downIco2-leave-to {
  transform: rotateZ(90deg);
}

.ti-item {
  .title {
    position: relative;
    max-width: 60vw;
    height: 2.2rem;
    line-height: 2.2rem;
  }
}
.unlock {
  border-radius: 0.9rem 0 0 0.9rem;
  background-color: #f6f6f6;
  height: 1.5rem;
  img {
    width: 0.75rem;
    height: 0.8rem;
    margin-right: 0.25rem;
    margin-left: 0.65rem;
    margin-top: auto;
    margin-bottom: auto;
  }
}
.ti-item-body {
  background: #f6f6f6;
  .item {
    margin-left: 0.75rem;
    padding-left: 1.1rem;
    height: 2.2rem;
    border-bottom: 1px solid #eeeeee;
    .Progress2 {
      padding-right: 0.75rem;
    }
    .body {
      margin-top: 0.25rem;
      position: relative;
      width: 2rem;
      height: 0.1rem;
      background: #ccc;
      border-radius: 0.15rem;
      overflow: hidden;
      .div {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0.1rem;
        display: flex;
        :nth-child(2) {
          height: 100%;
          background: #f16e69;
        }
        :nth-child(1) {
          height: 100%;
          background: #62c598;
        }
      }
    }
  }
}
.record {
  // transform: translate(-5px, -6px);
  width: 1.7rem;
  height: 0.75rem;
  margin-right: 0;
  position: absolute;
  right: -1.5rem;
  top: 0;
}
.right2 {
  align-items: center;
  img {
    width: 0.3rem;
    height: 0.4rem;
    margin-left: 0.4rem;
    margin-right: 0.75rem;
  }
}
.ti-item-title {
  padding-left: 0.75rem;
  height: 2.75rem;
  align-items: center;
  border-bottom: 1px solid #f8f8f8;
  box-sizing: border-box;
  .left {
    .down {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 0.4rem;
    }
  }

  .right {
    .Progress1 {
      padding-right: 0.75rem;
    }

    .body {
      margin-top: 0.2rem;
      position: relative;
      width: 3rem;
      height: 0.25rem;
      background: #f0f0f0;
      border-radius: 0.15rem;
      overflow: hidden;
      .div {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0.25rem;
        display: flex;
        :nth-child(2) {
          height: 100%;
          background: #f16e69;
        }
        :nth-child(1) {
          height: 100%;

          background: #62c598;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/chapter.vue